module.exports = __webpack_public_path__ + "img/icon-keyboard-blue.70e2af0c.png";